<template>
  <div>
    <b-form-group
      :state="state"
      :invalid-feedback="error"
    >
      <b-form-file
        v-model="file"
        :state="state"
        placeholder="Choose a CSV or ZIP..."
        drop-placeholder="Drop CSV here..."
        accept="application/zip,text/csv"
      ></b-form-file>
    </b-form-group>
  </div>
</template>
<script>
import _ from 'lodash'
export default {
  name: 'Zip',
  props: [],

  data: () => {
    return {
      loading: false,
      file: null,
      url: null,
      queries: [],
      error: null,
    }
  },

  watch: {
    async file() {
      this.error = null
      let queries = []
      if(this.file.type == 'application/zip') {
        await this.$loadScript('https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js')
        if(this.file.name.includes('Performance-on-Search')) {
          queries = await this.gscZip()
        } else {
          queries = await this.zip()
        }
      } else {
        queries = await this.csv()
      }
      this.filterUrls(queries)
      if(this.queries.length && !this.url) {
        this.url = window.prompt(`What URL are these ${this.queries.length} queries for?`)
      }
      try {
        new URL(this.url)
      } catch(e) {
        this.error = 'Unable to find a valid URL'
        return
      }
      _zyppy.track('Demo uploaded', {label: this.url, filename: this.file.name})
      this.$emit('input', {
        url: this.url,
        queries: this.queries,
      })
    },
    error() {
      if(this.error) {
        _zyppy.track('Demo error', {label: this.error})
      }
    }
  },
  computed: {
    state() {
      if(!this.file) {
        return null;
      }
      if(this.url && this.queries.length) {
        return null;
      }
      return false;
    }
  },
  methods: {
    loadScript(url) {
      return new Promise(resolve => {
        let script = document.createElement('script')
        script.onload = () => {
          resolve()
        }
        script.async = true
        script.src = url
        document.head.appendChild(script)
      })
    },
    csv2json(text) {
      const lines = text.split(/\n/).map(e => e.split(','))
      const fields = lines.shift()
      let config = {
        url:          [/(url|page)/i,              false],
        query:        [/(query|queries|keyword)/i, false],
        clicks:       [/click/i,                   true,   /(min|max)/i],
        impressions:  [/(impressions|volume)/i,    true,   /(min|max)/i],
        position:     [/(rank|position)/i,         true],
        ctr:          [/(ctr|rate)/i,              true],
      }
      let matches = _.mapValues(config, function([positive, isNumeric, negative = /^$/]) {
        return fields.findIndex((field, i) => {
          const isnan = isNaN(lines[0][i])
          return positive.test(field) && isNumeric != isnan && !negative.test(field)
        })
      })
      if(matches.clicks == -1) {
        matches.clicks = matches.impressions
      }
      if(matches.clicks == -1) {
        this.error = 'Unable to extract click data. CSVs must include a column labeled "clicks", "impressions" or "volume".'
        return []
      }
      if(matches.query == -1) {
        this.error = 'Unable to extract keyword/query data. CSVs must include a column labeled "keyword" or "query".'
        return []
      }
      matches = _.pickBy(matches, e => e != -1)
      const numericIndexes = _.values(_.pick(matches, _.keys(_.pickBy(config, 1))))
      return lines.map(e => {
        e = e.map((v,k) => numericIndexes.includes(k) ? Math.round(v) : v)
        return _.zipObject(
          _.keys(matches), 
          _.pullAt(e, _.values(matches))
        )
      }).filter(e => !/site:/.test(e.query))
    },
    async gscZip() {
      const zip = new JSZip();
      const contents = await zip.loadAsync(this.file)
      const pages = (await contents.file('Pages.csv').async('string'))
        .split(/\n/)
        .slice(1)
        .map(line => {
          const [url] = line.split(',')
          return {url}
        })
      if(pages.length > 2) {
        this.error = 'Not a single-page export. Within Google Search Console, click on the Pages tab, then click on a URL, then Export.'
        return []
      }
      const text = await contents.file('Queries.csv').async('string')
      const queries = this.csv2json(text)
      return queries.map(e => Object.assign(e, {url: pages[0].url}))
    },
    async zip() {
      const zip = new JSZip();
      const contents = await zip.loadAsync(this.file)
      const csvs = contents.file(/.*.csv$/i)
      if(!csvs.length) {
        this.error = 'No CSV in zipfile.'
        return []
      }
      if(csvs.length == 1) {
        return this.csv2json(await csvs[0].async('string'))
      }
      for(const csv of csvs) {
        const data = this.csv2json(csv)
        if(data.length) {
          return data
        }
      }
    },
    async csv() {
      return this.csv2json(await this.file.text())
    },
    async filterUrls(queries) {
      this.url = !_.get(queries, '[0].url') ? undefined : _.chain(queries)
        .groupBy('url')
        .entries()
        .maxBy(1)
        .head()
        .value()
      this.queries = queries
        .filter(e => e.url == this.url)
        .map(e => _.omit(e, 'url'))
    }
  }
}
</script>